import { BrandCode } from 'lib/config/config';
import { themeClass as celTheme } from 'theme/cel/theme.css';
import { themeClass as rciTheme } from 'theme/rci/theme.css';

export const themes = {
	[BrandCode.Celebrity]: celTheme,
	[BrandCode.RoyalCaribbean]: rciTheme,
};
